import { Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

const FormContainerLayout: FunctionComponent = ({ children }) => (
  <Flex sx={{ flexDirection: 'column', gap: '30px', width: '100%' }}>
    {children}
  </Flex>
);

export default FormContainerLayout;
